import styled from '@emotion/styled';
import { media, pxToCssFont, theme } from '@vfit/shared/themes';

// TODO: [refactoring] height
export const CoveredFirstSlide = styled.div`
  height: 500px;
  margin-bottom: 20px;
  position: relative;
`;

export const SliderCarouselContainer = styled.div`
  ${media.tablet`
    margin-bottom: ${theme.spacing.xl};
  `}

  ${media.desktop`
    margin-bottom: 120px;
  `}
`;

export const SlideContainer = styled.div<{ widht?: number; maxWidht?: number; height?: number }>`
  width: ${(props) => props.widht || `auto`};
  max-width: ${(props) => props.maxWidht || `auto`};
  height: ${(props) => props.height || `auto`};
  position: relative;
  marginbottom: ${theme.spacing.xl};
`;

export const TopTex = styled.div`
  margin: 48px 23px 31px 23px;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  ${pxToCssFont(30, 38)};
  text-align: center;

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};  
  `}
`;
export const StorybookWrapper = styled.div`
  .swiper-wrapper {
    display: flex;
  }
`;

